import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { FAQS } from "@/content/faq";
import { Reveal } from "@/components/motion/Reveal";
import { PlaceholderTag, SectionIntro } from "@/components/site/Bits";

export const FAQSection = () => (
  <section id="faq" className="section border-t border-white/[0.08]" data-testid="faq-section">
    <div className="container-x grid gap-12 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <SectionIntro
          eyebrow="FAQ"
          title={["Questions,", "answered."]}
          copy="Straight answers to what local business owners ask us most."
          testId="faq-heading"
        >
          <Reveal delay={0.2} className="mt-6">
            <PlaceholderTag testId="faq-draft-note">Draft answers · for founder review</PlaceholderTag>
          </Reveal>
        </SectionIntro>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion.Root type="single" collapsible defaultValue={FAQS[0].id} className="border-t border-white/[0.08]">
          {FAQS.map(({ id, q, a }) => (
            <Accordion.Item key={id} value={id} className="border-b border-white/[0.08]" data-testid={`faq-item-${id}`}>
              <Accordion.Header>
                <Accordion.Trigger
                  className="group flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-medium tracking-tight text-white transition-colors hover:text-white/80 sm:text-xl"
                  data-testid={`faq-trigger-${id}`}
                >
                  {q}
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full border border-white/15 transition-[transform,background-color] duration-300 group-hover:bg-white/[0.06] group-data-[state=open]:rotate-45">
                    <Plus className="h-4 w-4" aria-hidden="true" />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                <div className="pb-6 pr-10 leading-relaxed text-[#A1A1AA]" data-testid={`faq-answer-${id}`}>
                  {a}
                  <span className="mt-3 block font-mono text-xs uppercase tracking-wider text-[#2DD4D4]">Draft — for founder review</span>
                </div>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </Reveal>
    </div>
  </section>
);
